import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationAssayResponse, ConfigurationAssayPatchInBatchRequest, ConfigurationAssayCreateRequest } from '@/modules/configurationModule/detail/assays/configuration-assays/services/configuration-assay/configuration-assay.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class ConfigurationAssayService {
    async create(request: ConfigurationAssayCreateRequest): Promise<ConfigurationAssayResponse> {
        const response = await axios.post<ConfigurationAssayResponse>(`/configuration/assay`, request)
        return response.data
    }

    async paginator(filterModel?: CommonFilterModel, params?: CommonParams): Promise<IResponseAgGrid<ConfigurationAssayResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAssayResponse>>(`/configuration/assay/`, { ...filterModel }, { params })
        response.data.content = orderBy(response.data.content, (element: ConfigurationAssayResponse) => TextNormalization.removeDiacritics(element.name), ['asc'])
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/assay/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationAssayPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/assay/batch`, request)
        return response.data
    }
}
export const configurationAssayService = new ConfigurationAssayService()
